import { PLATFORM } from '@/common/constants/platform-constants';
import React from 'react';
import qrCodeWoa from '@/asserts/images/qr-code-woa.png';
import qrCode from '@/asserts/images/qr-code.png';
import ExternalModule from './external-module';

export const SiteQrCode = {
  [PLATFORM.STANDALONE]: qrCode,
  [PLATFORM.STANDALONE_WOA]: qrCodeWoa,
};

export const SiteExternalModule = {
  [PLATFORM.STANDALONE]: null,
  [PLATFORM.STANDALONE_WOA]: <ExternalModule />,
};

export const SiteHelpDocsLink = {
  [PLATFORM.STANDALONE]: [
    { label: '帮助文档', link: '/docs' },
    { label: '最佳实践', link: '/docs#/apps/fc/ifbook/docs/best-practice/interface-managment' },
  ],
  [PLATFORM.STANDALONE_WOA]: [
    { label: '帮助文档', link: '//ifbook.pages.woa.com/#/' },
    { label: '最佳实践', link: '//ifbook.pages.woa.com/#/apps/woa/ifbook-ext-zhiyan/docs/best-practice/interface-managment' },
  ],
};

export const SiteRules = {
  [PLATFORM.STANDALONE]: [
    {
      label: '隐私政策',
      link: 'https://rule.tencent.com/rule/202409200002',
    },
    {
      label: '用户协议',
      link: 'https://rule.tencent.com/rule/202409200001',
    },
  ],
  [PLATFORM.STANDALONE_WOA]: [],
};
